// extracted by mini-css-extract-plugin
var _1 = "RegistrationForm-modulehelpText__wVqBY AuthHelpText-moduleAuthHelpText__HX0rS";
var _2 = "RegistrationForm-modulelicense__v5nNP AuthLicense-moduleAuthLicense__m52dv";
var _3 = "RegistrationForm-moduletitle__N2cCO AuthTitle-moduleAuthTitle__VKaTa";
var _4 = "RegistrationForm-modulewithNotifications__lC_VO";
export { _1 as "helpText", _2 as "license", _3 as "title", _4 as "withNotifications" }
